import React, { PureComponent } from "react"
import { map, isEqual } from 'lodash-es'
import NavBar from "./navigation/nav-bar"
import { Link } from "react-router-dom"
import SortingWidget from './ui/sorting-widget'
import "antd/lib/tree-select/style/css"
import StatisticsPageHero from './ui/statistics-page-hero'
import NavStatistics from './navigation/nav-statistics'
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import Button from './ui/button'
import DriverStat from './ui/driver-stat'
import ViewToggler from './ui/view-toggler'
import CompactStatRow from './ui/compact-stat-row'
import styled from 'styled-components'
import { TABLET, LAPTOP, DESKTOP } from '../utilities/breakpoints'
import { formPagePath } from '../utilities/route'
import ParameterFilter from './ui/parameter-filter'
import { YOU_FILTER } from '../utilities/helpers'
import { sortingService } from '../utilities/sortingService'
import { Survey } from '../utilities/Survey'
import { mergeWithStatistics, likertResponseToPercentage } from '../utilities/statistics'

class FinishPageDetails extends PureComponent {

  constructor(props) {
    super(props);
    const _surveyBeingEdited = sessionStorage.getItem("surveyBeingEdited") || false;
    this.state = {
      surveyBeingEdited: !!(_surveyBeingEdited && _surveyBeingEdited === "true"),
    };
  }

  t = (phrase) => {
    const { useTranslate } = this.props;

    return useTranslate(`data_vault.${phrase}`);
  }

  handleFiltersChange = value => {
    this.props.onSetFilters(value);
  }

  handleViewModeChange = viewMode => {
    this.props.onSetDriversViewMode(viewMode);
  }

  render() {
    const {
      match: {
        params: { surveyId, languageCode },
      },
      surveyStatistics,
      respondentParameters,
      questionnaire,
      questionnaire: {
        canViewAfterGame,
        isAfterGameGuest,
        isFinished,
        canAnswer,
        logo,
        isDialogueActive,
        areProgressReportsActive
      },
      useTranslate,
      sortingType,
      sortAscending,
      driversViewMode,
      filters,
      improvementProject
    } = this.props;

    const toStatistics = formPagePath(languageCode, surveyId, 'finish', 'themes')
    const toEditAnswers = formPagePath(languageCode, surveyId)

    const title = (!canViewAfterGame && !isAfterGameGuest)
      ? useTranslate("survey_finished.your_statistics_page_title")
      : useTranslate("data_vault.statistics_page_title")

    const startEditingSurvey = () => {
      sessionStorage.setItem("surveyBeingEdited", "true");
      this.setState({surveyBeingEdited: true});
    }

    const isAfterGame = (canViewAfterGame || isAfterGameGuest)
    const sortingFunction = sortingService.getSortingFunction(sortingType);
    let sortedDrivers
    const notEnoughRespondents = surveyStatistics.__typename === 'NotEnoughRespondentsError'
    if (!notEnoughRespondents) {
      const survey = new Survey(questionnaire.catalysts, respondentParameters)
      sortedDrivers = mergeWithStatistics(survey.getDrivers(), surveyStatistics.drivers).map(driver => {
        const themeId = survey.getThemeIdByDriverId(driver.id)
        return {
          title: driver.title,
          description: driver.description,
          result: likertResponseToPercentage(driver.statistics.aggregatedResponse),
          rate: driver.statistics.aggregatedImportance,
          theme: { title: survey.getTheme(themeId).title, surveyThemeIndex: survey.getSurveyThemeIndex(themeId) },
          questions: mergeWithStatistics(survey.getLikertQuestions(), surveyStatistics.questions)
            .filter(question => driver.affectingQuestionIds.includes(question.id))
            .map(question => ({
              id: question.id,
              title: question.title,
              result: likertResponseToPercentage(question.statistics.aggregatedResponse),
              rate: question.statistics.aggregatedImportance,
              skipped: question.statistics.skippedRespondentCount,
              participants: question.statistics.totalRespondentCount,
              respondentGroups: isAfterGame ? survey.getRespondentGroups(question.id, 'likert') : undefined
            }))
        }
      }).sort(sortingFunction(sortAscending ? sortAscending : false));
    }

    const showDistribution = (canViewAfterGame || isAfterGameGuest) && !isEqual(filters, YOU_FILTER);

    return (
      <section className="finish-page finish-page--drivers">
        <StatisticsPageHero>
          <div className="aftergame-page-container">
            <NavBar
              to={isFinished && !canViewAfterGame && toStatistics}
              afterGame
              inverse={true}
              logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"statistics"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={areProgressReportsActive}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="aftergame-page-container">
            <div className="finish-page__intro">
              <h1>{title}</h1>
              { (!canViewAfterGame && !isAfterGameGuest) ?
                <div className="stats-description">
                  <p>{useTranslate("survey_finished.your_statistics_page_description")}</p>
                  { (isFinished && !canViewAfterGame && canAnswer) &&
                    <div>
                      <Button
                        as={Link}
                        to={toEditAnswers}
                        onClick={() => startEditingSurvey()}
                        size={"md"}
                      >
                        {this.t("edit_answers_button")}
                      </Button>
                    </div>
                  }
                </div>
                :
                <div className="stats-description">
                  <p>{useTranslate("data_vault.statistics_page_description")}</p>
                </div>
              }

              <div className="finish-page__intro__nav-holder">
                <NavStatistics
                  activePage={"drivers"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  questionnaire={questionnaire}
                />
              </div>
            </div>
          </div>
        </StatisticsPageHero>

        <div className="aftergame-page-container statistics-page-content finish-page__stats pb-5">
          <div className="finish-page__filters">
            {((canViewAfterGame || isAfterGameGuest) && respondentParameters.length > 0)  && (
              <ParameterFilter
                filters={filters}
                handleFiltersChange={this.handleFiltersChange}
                respondentParameters={respondentParameters}
                isAfterGameGuest={isAfterGameGuest}
                useTranslate={useTranslate}
              />
            )}
            <ViewToggler
              viewMode={driversViewMode}
              handleVMChange={this.handleViewModeChange}
              useTranslate={useTranslate}
            />
            <SortingWidget useTranslate={useTranslate} />
          </div>
          {(!notEnoughRespondents && sortedDrivers.length > 0) ?
            (driversViewMode === "compact" ?
                <CompactListContainer>
                  {map(sortedDrivers, (driver, index) => (
                    <CompactStatRow
                      key={index}
                      index={index}
                      surveyThemeIndex={driver.theme.surveyThemeIndex}
                      type={"driver"}
                      result={driver.result}
                      rate={driver.rate}
                      title={driver.title}
                      useTranslate={useTranslate}
                      showLabels={index === 0}
                      showNumbers={false}
                    />
                  ))}
                </CompactListContainer>
              :
              map(sortedDrivers, (driver, index) => (
                <div
                  key={index}
                  className="d-flex bg-white finish-page__stats--details finish-page__stats--details--with-padding flex-column mt-3 bs"
                >
                  <DriverStat
                    index={index}
                    driverStats={{ "result": driver.result, "rate": driver.rate }}
                    driverTitle={driver.title}
                    driverDescription={driver.description}
                    theme={driver.theme}
                    questions={driver.questions}
                    useTranslate={useTranslate}
                    surveyId={surveyId}
                    questionnaire={this.props.questionnaire}
                    sortBy={sortingFunction}
                    ascending={sortAscending}
                    filters={filters}
                    showDistribution={showDistribution}
                  />
                </div>
              ))
            )
            :
            <p>{useTranslate("data_vault.no_results_for_parameter")}</p>
          }
        </div>
      </section>
    );
  }
}

export default FinishPageDetails

const CompactListContainer = styled.div`
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 10px;
  
  @media${TABLET} {
    padding: 30px 20px 20px;
  }
  
  @media${LAPTOP} {
    padding: 40px 30px 30px;
  }
  @media${DESKTOP} {
    padding: 40px 40px 30px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/statistics-page-drivers.js